import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

import GroupsFormContainer from '../../containers/organizations/GroupsFormContainer.jsx';

const EditOrganization = ({ slug }) => (
  <>
    <Helmet>
      <title>Edit Organization | ChangeSync</title>
    </Helmet>
    <GroupsFormContainer slug={slug} />
  </>
);

EditOrganization.getInitialProps = ({ query }) => ({
  slug: query.slug,
});

export default requireAuth(withRouterParams(EditOrganization));
